import _ from "lodash";

export default ({ schema: { min, type }, validation: { min: message } }) =>
	_.isNumber(min) && type === "number" && ["min", _.template(message)({ model: { min } }), min];
